import React from 'react';

interface PageContainerProps {
  children: React.ReactNode;
  /** 세로 패딩 */
  padded?: 'none' | 'sm' | 'md' | 'lg';
  className?: string;
}

const PAD_Y: Record<NonNullable<PageContainerProps['padded']>, string> = {
  none: '',
  sm: 'py-3',
  md: 'py-6',
  lg: 'py-8',
};

/**
 * 페이지 최대 폭 컨테이너 — w-[98vw] 반복을 대체.
 *
 * 가로 safe-area(가로모드 노치)를 여기서 한 번에 흡수하므로 개별 페이지는 좌우 패딩을 따로 두지 않는다.
 *
 * ⚠️ sm 이상에서도 safe-area 를 하한으로 유지해야 한다. inset 이 0 이 아닌 상황(가로모드 노치)은
 * 뷰포트 폭이 항상 640px 이상이라, `sm:px-4` 같은 고정값으로 덮으면 정작 필요한 모든 경우에
 * safe-area 가 무력화된다.
 */
const PageContainer: React.FC<PageContainerProps> = ({ children, padded = 'md', className = '' }) => (
  <div
    className={`w-full max-w-[98vw] mx-auto pl-[max(0.75rem,env(safe-area-inset-left))] pr-[max(0.75rem,env(safe-area-inset-right))] sm:pl-[max(1rem,env(safe-area-inset-left))] sm:pr-[max(1rem,env(safe-area-inset-right))] ${PAD_Y[padded]} ${className}`}
  >
    {children}
  </div>
);

export default PageContainer;
